module.exports = __webpack_public_path__ + "static/img/2.3ebb6786.png";